export function trackBookingTimeSelect(title) {
    dataLayer.push({
        event: 'bookingTimeSelect',
        experience: title,
    });
}

export function trackBookingTimeEdit(title) {
    dataLayer.push({
        event: 'bookingTimeEdit',
        experience: title,
    });
}

export function trackBookingDateSelect(title) {
    dataLayer.push({
        event: 'bookingDateSelect',
        experience: title,
    });
}

export function trackBookingOffersExpand(title, experienceType) {
    dataLayer.push({
        event: 'bookingOffersExpand',
        experience: title,
        experienceType,
    });
}

export function trackBookingDateEdit(title) {
    dataLayer.push({
        event: 'bookingDateEdit',
        experience: title,
    });
}

export function trackPersonalInfoSubmitted(title, location, experienceType, price) {
    dataLayer.push({
        event: 'personalInfoSubmitted',
        experience: title,
        location,
        experienceType,
        price,
    });
}

export function trackCouponCodeClick(title) {
    dataLayer.push({
        event: 'couponCodeClick',
        experience: title,
    });
}

export function trackCouponCodeApply(title) {
    dataLayer.push({
        event: 'couponCodeApply',
        experience: title,
    });
}

export function trackBookingDetailsSubmit(title, location, experienceType, price) {
    dataLayer.push({
        event: 'bookingDetailsSubmit',
        experience: title,
        location,
        experienceType,
        price,
    });
}

export function trackBookingSuccesfull(title, location, experienceType, price) {
    dataLayer.push({
        event: 'bookingSuccesfull',
        experience: title,
        location,
        experienceType,
        price,
    });
}

export function trackQrCodeBookingSuccesfull(title, campaingSource, connectPartner, connectAssociate, price) {
    dataLayer.push({
        event: 'qrCodeBookingSuccesfull',
        experience: title,
        campaingSource,
        connectPartner,
        connectAssociate,
        price,
    });
}